import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Home.css';

const ADMIN_API = 'https://admin.riymay.com/api/v1/admin';

const Home = () => {
  const [shelves, setShelves] = useState([]);
  const [banners, setBanners] = useState([]);
  const [heroMedia, setHeroMedia] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${ADMIN_API}/homepage/data`)
      .then(r => r.json())
      .then(d => {
        setShelves(d.shelves || []);
        setBanners(d.banners || []);
      })
      .catch(() => {});

    fetch(`${ADMIN_API}/hero-section/media`)
      .then(r => r.json())
      .then(d => {
        const active = (d.heroSectionMedia || []).find(m => m.activeStatus === 'active');
        setHeroMedia(active || null);
      })
      .catch(() => {});
  }, []);

  const heroStyle = heroMedia
    ? { backgroundImage: `url(https://riymay.com/assets/${heroMedia.fileName})` }
    : {};

  return (
    <div className="home-page">

      {/* ── HERO ── */}
      <section className="home-hero" style={heroStyle} id="home-hero">
        <div className="home-hero-overlay" />
        <div className="home-hero-scroll">
          <div className="home-hero-scroll-line" />
          <span>scroll</span>
        </div>
      </section>

      {/* ── LATEST DROP ── */}
      {shelves.length > 0 && (
        <section className="home-latest">
          <div className="home-section-label">Latest drop</div>
          {shelves.map(shelf => (
            <div key={shelf._id} className="home-shelf">
              <h2 className="home-shelf-name">{shelf.name}</h2>
              <div className="home-shelf-grid">
                {shelf.products.map(product => (
                  <div
                    key={product._id}
                    className="home-product-card"
                    onClick={() => navigate(`/product/${product._id}`)}
                  >
                    {product.images && product.images[0] ? (
                      <img
                        src={`https://riymay.com/assets/${product.images[0].url}`}
                        alt={product.name}
                        className="home-product-img"
                      />
                    ) : (
                      <div className="home-product-img-placeholder" />
                    )}
                    <div className="home-product-info">
                      <span className="home-product-name">{product.name}</span>
                      <span className="home-product-price">₹{product.price}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </section>
      )}

      {/* ── COLLECTIONS ── */}
      {banners.length > 0 && (
        <section className="home-collections">
          <div className="home-section-label">Collections</div>
          {banners.map(banner => (
            <Link key={banner._id} to={banner.link || '/products-collection'} className="home-collection-banner">
              {banner.imageUrl && (
                <img
                  src={`https://riymay.com/assets/${banner.imageUrl}`}
                  alt={banner.title}
                  className="home-collection-bg"
                />
              )}
              <div className="home-collection-overlay" />
              <div className="home-collection-content">
                <span className="home-collection-title">{banner.title}</span>
                <span className="home-collection-cta">Explore →</span>
              </div>
            </Link>
          ))}
        </section>
      )}

    </div>
  );
};

export default Home;
